import '../../assets/styles/auth.scss'
import '../../assets/styles/pages.scss'
import { Link, useLocation, useMatch, useNavigate } from 'react-router-dom'
import { Fragment, useContext, useEffect, useState } from 'react'
import { GlobalContext, handleError } from '../../context/Provider'
import henceforthApi from '../../utils/henceforthApi'
import moment from 'moment'
import { CURRENCY_SYMBOL } from '../../utils/henceforthApi'
import { numberWithCommas } from '../../utils/validations'
import Spinner from '../../components/BootstrapCompo'
import BreadCrumb from '../../components/common/BreadCrumb'
import PaginationLayout from '../../components/PaginationLayout'
import { toast } from 'react-toastify'
import NODATA from '../../assets/images/no-data-found.svg'
import { INSUFFICIENT_PERMISSIONS } from '../../context/actionTypes'
import SignedImage from '../../components/SignedImage'

const PayoutPage = () => {
    let breadCrumbPath = [
        { name: 'Home', url: `/`, active: '' },
        { name: 'Payout Requests', url: ``, active: 'not-allowed' }
    ]
    const { authState, loading, setLoading, authDispatch } = useContext(GlobalContext)

    const location = useLocation()
    let limit = 10;
    const navigate = useNavigate()
    const match = useMatch('/payout-requests/:page')
    const newParam = new URLSearchParams(location.search);

    const [state, setstate] = useState({
        data: [] as any,
        total_count: 0
    })

    const initialise = async () => {
        setLoading(true)
        try {
            let apires = await henceforthApi.Payout.list(
                Number(match?.params.page) - 1,
                limit,
                newParam.get('status') || '',
                newParam.get('seller_id') || ''
            )
            setstate({
                data: apires?.data?.data || [],
                total_count: apires?.data?.total_count || 0
            })
        } catch (error: any) {
            handleError(error)
        } finally {
            setLoading(false)
        }
    }

    const onChangePagination = (newval: any) => {
        navigate({ pathname: `/payout-requests/${newval}`, search: newParam.toString() })
    }

    useEffect(() => {
        initialise()
    }, [match?.params.page, authState?.lang, newParam.get('status'), newParam.get('seller_id')])

    return (
        <>
            <BreadCrumb pathNameDeclare={breadCrumbPath} />

            <div className='page-spacing'>
                <section className='product-listing'>
                    <div className='product-detail-box'>

                        {loading ? <div className='d-flex justify-content-center py-5'><Spinner /></div> :
                            <div className="common-card">
                                <div className="common-card-title">
                                    <h5>Payout Requests</h5>
                                </div>
                                <div className="common-card-content">
                                    <div className='data-list-table table-responsive mb-3'>
                                        <table className="table table-striped align-middle">
                                            <thead>
                                                <tr>
                                                    <th>Sr.No</th>
                                                    <th>Seller</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Requested Date</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Array.isArray(state?.data) && (state?.data.length) ? state.data.map((res: any, index) => (
                                                    <tr key={res._id}>
                                                        <td>{(Number(match?.params.page) - 1) * limit + index + 1}</td>
                                                        <td>
                                                            <div className="d-flex align-items-center gap-1">


                                                                <div className='product-image-table mr-3 gap-3'>
                                                                    <SignedImage
                                                                        src={res.seller_details?.image || ""}
                                                                        fallback={res.seller_details?.name}
                                                                        alt="img"
                                                                        size="small"

                                                                    />
                                                                </div>

                                                                <div>
                                                                    <div className="fw-bold">{res.seller_details?.name || 'N/A'}</div>
                                                                    <small className="text-muted">{res.seller_details?.email}</small>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{CURRENCY_SYMBOL}{numberWithCommas(res.amount || 0)}</td>
                                                        <td>
                                                            <span className={`badge bg-${res.status === 'PENDING' ? 'warning' : res.status === 'ACCEPTED' ? 'success' : 'danger'}`}>
                                                                {res.status}
                                                            </span>
                                                        </td>
                                                        <td>{moment(res.created_at).format('DD MMM YYYY, hh:mm A')}</td>
                                                        <td>
                                                            <Link to={`/payout-details/${res._id}`} className="btn btn-sm btn-outline-primary">
                                                                <i className="fa fa-eye me-1"></i> View Details
                                                            </Link>
                                                        </td>
                                                    </tr>
                                                ))
                                                    : <tr><td colSpan={6} className="text-center py-3"><img src={NODATA} width="100" /><p className='text-center mt-3'>No data found</p></td></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className='dashboad-pagination-box'>
                                        <PaginationLayout
                                            count={state?.total_count || 0}
                                            data={state?.data}
                                            page={Number(match?.params.page)}
                                            limit={Number(limit)}
                                            onPageChange={(val: any) => onChangePagination(val)}
                                        />
                                    </div>
                                </div>
                            </div>}
                    </div>
                </section>
            </div>
        </>
    )
}

export default PayoutPage;
